import { FolderableType } from 'FoldersApp/enums/folderable-type.enum';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
import { setChartId } from '../state/chart-id/chart-id.action';
import * as i0 from "@angular/core";
export class SelectedScatterPlotService extends SelectedFolderableService {
    constructor() {
        super(...arguments);
        this.RESOURCE_TYPE = FolderableType.SCATTER_PLOT;
        this.ITEM_ID_SLICE_KEY = 'chartId';
    }
    clearSelection() {
        super.clearSelection();
        this.store.dispatch(setChartId({
            chartId: null,
        }));
    }
}
SelectedScatterPlotService.ɵfac = /*@__PURE__*/ (() => { let ɵSelectedScatterPlotService_BaseFactory; return function SelectedScatterPlotService_Factory(__ngFactoryType__) { return (ɵSelectedScatterPlotService_BaseFactory || (ɵSelectedScatterPlotService_BaseFactory = i0.ɵɵgetInheritedFactory(SelectedScatterPlotService)))(__ngFactoryType__ || SelectedScatterPlotService); }; })();
SelectedScatterPlotService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SelectedScatterPlotService, factory: SelectedScatterPlotService.ɵfac });
